import { useState } from 'react';

import TextOverflowTooltip from '@atom/components/common/tooltip/TextOverflowTooltip';
import { TextField } from '@atom/mui';
import colors from '@atom/styles/colors';
import fonts from '@atom/styles/fonts';
import { WorkOrderField } from '@atom/types/work';
import { PREVIEW_FIELD_WIDTH } from '@atom/utilities/taskUtilities';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';

const styles = {
  unitsStyle: {
    textTransform: 'uppercase',
  },
  textField: {
    width: PREVIEW_FIELD_WIDTH,
  },
};

interface Props {
  field: WorkOrderField;
  onChange: (fieldId: string, value: any) => void;
  onBlur: (fieldId: string, value: any) => void;
  isDisabled?: boolean;
}

const WorkOrderNumericField = ({
  field,
  onChange,
  onBlur,
  isDisabled,
}: Props) => {
  const [value, setValue] = useState<any>(
    !isNilOrEmpty(field?.value) ? field?.value : '',
  );

  const handleChange = event => {
    const number =
      event.target.value === '' ? '' : parseFloat(event.target.value);
    setValue(number);
    onChange(field.id, number);
  };

  const handleOnBlur = event => {
    const number =
      event.target.value === '' ? '' : parseFloat(event.target.value);

    if (field?.value !== number) {
      setValue(number);
      onBlur(field.id, number);
    }
  };

  const title = field.required ? `* ${field.title}` : field.title;
  const fieldUnit = field?.units ? ` (${field?.units})` : '';

  return (
    <div>
      <TextOverflowTooltip
        width={PREVIEW_FIELD_WIDTH}
        text={title + fieldUnit}
        color={colors.neutral.dim}
        fontSize={fonts.sm}
      />
      <TextField
        id={field.id}
        style={styles.textField}
        type="number"
        value={value}
        disabled={isDisabled}
        onChange={handleChange}
        onBlur={handleOnBlur}
      />
    </div>
  );
};

export default WorkOrderNumericField;
